import { render, staticRenderFns } from "./FavouritesPage.vue?vue&type=template&id=2aceaa0e"
import script from "./FavouritesPage.vue?vue&type=script&lang=js"
export * from "./FavouritesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports